module.exports = __webpack_public_path__ + "assets/apolyPille_default.89663261.png";